var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16699 3.33464C5.94533 3.33464 3.33366 5.94631 3.33366 9.16797C3.33366 12.3896 5.94533 15.0013 9.16699 15.0013C12.3887 15.0013 15.0003 12.3896 15.0003 9.16797C15.0003 5.94631 12.3887 3.33464 9.16699 3.33464ZM1.66699 9.16797C1.66699 5.02583 5.02486 1.66797 9.16699 1.66797C13.3091 1.66797 16.667 5.02583 16.667 9.16797C16.667 13.3101 13.3091 16.668 9.16699 16.668C5.02486 16.668 1.66699 13.3101 1.66699 9.16797Z",
    fill: "#798AA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5781 13.58C13.9035 13.2546 14.4311 13.2546 14.7566 13.58L18.0899 16.9133C18.4153 17.2388 18.4153 17.7664 18.0899 18.0919C17.7645 18.4173 17.2368 18.4173 16.9114 18.0919L13.5781 14.7585C13.2526 14.4331 13.2526 13.9055 13.5781 13.58Z",
    fill: "#798AA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.51fc55cbd4c6227f29b2a18cc9ebe550.svg";
export { ForwardRef as ReactComponent };